import { CText } from '../@shared/models/text.model';
import { Type } from 'class-transformer';

export class CCPData {
    readonly layout: string;
    readonly text: string;
    @Type(() => Feed)
    readonly feed: Feed[];
    readonly banner: Banner | null;
    readonly timerStrip: any;

    tabs: Array<{ text: string; link: string; active: boolean }>;
    items: Array<Item>;

    constructor(
        layout: string = '',
        text: string = '',
        feed: Feed[] = [],
        banner: Banner | null = null,
        timerStrip?: any
    ) {
        this.layout = layout;
        this.text = text;
        this.feed = feed;
        this.banner = banner;
        this.timerStrip = timerStrip;
        this.generateSyntheticFields();
        this.tabs = [];
        this.items = [];
    }

    changeActiveTab(tabIndex: number) {
        this.tabs[tabIndex].active = true;
        this.updateItemsList();
    }

    private generateSyntheticFields() {
        this.tabs = [];
        for (const item of this.feed) {
            this.tabs.push({
                text: item.text,
                link: item.link,
                active: item.active,
            });
        }
        this.updateItemsList();
    }

    private updateItemsList() {
        this.items = [];
        for (const item of this.feed) {
            if (item.active) {
                this.items = item.items;
            }
        }
    }

    isHeaderVisible() {
        return this.text !== '';
    }

    areTabsVisible() {
        return this.tabs.length > 1;
    }
}

export class Feed {
    link: string;
    active: boolean;
    text: string;
    @Type(() => Item)
    items: Item[];

    constructor(link: string, active: boolean, text: string, items: Item[]) {
        this.link = link;
        this.active = active;
        this.text = text;
        this.items = items;
    }
}

export class Item {
    link: string;
    image: string;
    @Type(() => CText)
    title: CText;
    newLaunch?: boolean;
    background: { color: string };

    constructor(
        link: string,
        image: string,
        title: CText,
        background: { color: string }
    ) {
        this.link = link;
        this.image = image;
        this.title = title;
        this.background = background;
    }
}
export class CCPSEO {
    breadCrumbs: Array<{
        item: string;
        link: string;
        name: string;
        position: number;
        text: string;
        type: string;
    }>;
    canonical: string;
    footerContent?: any | null;
    meta?: any;
    ogImage: string;
    langAlternates: Array<{
        href: string;
        hreflang: string;
    }>;
    faq: Array<any>;

    constructor() {
        this.langAlternates = [];
        this.canonical = '';
        this.ogImage = '';
        this.breadCrumbs = [];
        this.faq = [];
    }
}
export class Banner {
    image: string;
    scrim?: { color: string; alpha: string };
    video?: string;
    link: string;

    constructor() {
        this.image = '';
        this.video = '';
        this.link = '';
        this.scrim = {
            color: '',
            alpha: '',
        };
    }
}
